module.exports = __webpack_public_path__ + "static_portal/img/recognized_joints.8a406427.png";